"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8573],{

/***/ 18573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ ProductIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js
var v4 = __webpack_require__(72045);
;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/core-icon.js

var CoreIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "42",
        height: "42",
        viewBox: "0 0 42 42",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.648 5.7101C25.648 3.12517 23.5536 1.02966 20.97 1.02966C18.3864 1.02966 16.292 3.12517 16.292 5.7101V10.8542C16.292 13.4392 18.3864 15.5347 20.97 15.5347C23.5536 15.5347 25.648 13.4392 25.648 10.8542V5.7101Z",
                fill: "url(#paint0_linear_1894_128244)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.34254 12.2735C4.88412 11.4748 2.24397 12.8191 1.44559 15.2763C0.647212 17.7334 1.99294 20.3729 4.45136 21.1717L9.34372 22.7613C11.8021 23.5601 14.4423 22.2157 15.2407 19.7586C16.0391 17.3014 14.6933 14.662 12.2349 13.8632L7.34254 12.2735Z",
                fill: "url(#paint1_linear_1894_128244)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.9192 31.7187C6.39981 33.81 6.86253 36.7364 8.9527 38.255C11.0429 39.7736 13.969 39.3093 15.4884 37.2181L18.512 33.0564C20.0314 30.9651 19.5687 28.0388 17.4785 26.5202C15.3884 25.0016 12.4622 25.4658 10.9428 27.557L7.9192 31.7187Z",
                fill: "url(#paint2_linear_1894_128244)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.5967 37.1648C28.1161 39.2561 31.0422 39.7203 33.1324 38.2017C35.2226 36.6831 35.6853 33.7567 34.1659 31.6655L31.1423 27.5038C29.6229 25.4125 26.6967 24.9483 24.6066 26.4669C22.5164 27.9855 22.0537 30.9119 23.5731 33.0031L26.5967 37.1648Z",
                fill: "url(#paint3_linear_1894_128244)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.0168 26.2007C23.5804 26.2007 25.6586 24.1225 25.6586 21.5589C25.6586 18.9953 23.5804 16.9171 21.0168 16.9171C18.4532 16.9171 16.375 18.9953 16.375 21.5589C16.375 24.1225 18.4532 26.2007 21.0168 26.2007Z",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.87306 21.3748C8.45058 21.3748 10.5401 19.2853 10.5401 16.7078C10.5401 14.1303 8.45058 12.0408 5.87306 12.0408C3.29555 12.0408 1.20605 14.1303 1.20605 16.7078C1.20605 19.2853 3.29555 21.3748 5.87306 21.3748Z",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.9712 10.3467C23.5533 10.3467 25.6466 8.25353 25.6466 5.67142C25.6466 3.08931 23.5533 0.996094 20.9712 0.996094C18.3891 0.996094 16.2959 3.08931 16.2959 5.67142C16.2959 8.25353 18.3891 10.3467 20.9712 10.3467Z",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.7039 39.1605C14.2905 39.1605 16.3873 37.0637 16.3873 34.4771C16.3873 31.8905 14.2905 29.7937 11.7039 29.7937C9.11733 29.7937 7.02051 31.8905 7.02051 34.4771C7.02051 37.0637 9.11733 39.1605 11.7039 39.1605Z",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.3911 39.1112C32.9721 39.1112 35.0644 37.0189 35.0644 34.4379C35.0644 31.8568 32.9721 29.7645 30.3911 29.7645C27.8101 29.7645 25.7178 31.8568 25.7178 34.4379C25.7178 37.0189 27.8101 39.1112 30.3911 39.1112Z",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.6575 12.2735C37.1159 11.4748 39.756 12.8191 40.5544 15.2763C41.3528 17.7334 40.0071 20.3729 37.5486 21.1717L32.6563 22.7613C30.1979 23.5601 27.5577 22.2157 26.7593 19.7586C25.9609 17.3014 27.3067 14.662 29.7651 13.8632L34.6575 12.2735Z",
                fill: "url(#paint4_linear_1894_128244)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.1269 21.3749C33.5494 21.3749 31.4599 19.2854 31.4599 16.7079C31.4599 14.1304 33.5494 12.0409 36.1269 12.0409C38.7045 12.0409 40.7939 14.1304 40.7939 16.7079C40.7939 19.2854 38.7045 21.3749 36.1269 21.3749Z",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_1894_128244",
                        x1: "20.9394",
                        y1: "-7.95948",
                        x2: "21.0423",
                        y2: "16.4694",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.411458",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_1894_128244",
                        x1: "-7.11305",
                        y1: "12.5276",
                        x2: "16.152",
                        y2: "19.9787",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.411458",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_1894_128244",
                        x1: "3.69378",
                        y1: "45.5453",
                        x2: "17.9695",
                        y2: "25.7215",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.411458",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_1894_128244",
                        x1: "38.4408",
                        y1: "45.4561",
                        x2: "23.9987",
                        y2: "25.7532",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.411458",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_1894_128244",
                        x1: "49.1131",
                        y1: "12.5276",
                        x2: "25.848",
                        y2: "19.9787",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.411458",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#6C6CFF",
                                "stop-opacity": "0.1"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/core-white.js

var CoreWhiteIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "60",
        height: "56",
        viewBox: "0 0 60 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Group 1261161825",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Group 1261159924",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Vector",
                            d: "M29.6617 35.1084C33.2823 35.1084 36.2174 32.2687 36.2174 28.7659C36.2174 25.263 33.2823 22.4233 29.6617 22.4233C26.0411 22.4233 23.106 25.263 23.106 28.7659C23.106 32.2687 26.0411 35.1084 29.6617 35.1084Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "Group 1261159917",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_2",
                                    d: "M36.4365 7.10771C36.4365 3.57568 33.4784 0.712402 29.8296 0.712402C26.1807 0.712402 23.2227 3.57568 23.2227 7.10771V14.1366C23.2227 17.6686 26.1807 20.5319 29.8296 20.5319C33.4784 20.5319 36.4365 17.6686 36.4365 14.1366V7.10771Z",
                                    fill: "url(#paint0_linear_3732_1157)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_3",
                                    d: "M10.583 16.0767C7.11087 14.9853 3.3821 16.8222 2.25454 20.1796C1.12697 23.5371 3.02758 27.1436 6.49967 28.235L13.4093 30.4071C16.8814 31.4986 20.6101 29.6616 21.7377 26.3042C22.8653 22.9468 20.9647 19.3402 17.4926 18.2488L10.583 16.0767Z",
                                    fill: "url(#paint1_linear_3732_1157)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_4",
                                    d: "M11.3969 42.6448C9.25104 45.5023 9.90455 49.5009 12.8566 51.5759C15.8086 53.6509 19.9412 53.0166 22.0871 50.1591L26.3575 44.4726C28.5034 41.6151 27.8498 37.6166 24.8978 35.5415C21.9458 33.4665 17.8132 34.1009 15.6673 36.9583L11.3969 42.6448Z",
                                    fill: "url(#paint2_linear_3732_1157)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_5",
                                    d: "M37.7764 50.0874C39.9223 52.9449 44.0549 53.5792 47.007 51.5042C49.959 49.4292 50.6125 45.4306 48.4666 42.5732L44.1962 36.8867C42.0504 34.0292 37.9177 33.3949 34.9657 35.4699C32.0137 37.5449 31.3602 41.5434 33.506 44.4009L37.7764 50.0874Z",
                                    fill: "url(#paint3_linear_3732_1157)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_6",
                                    d: "M8.50834 28.5142C12.1486 28.5142 15.0997 25.6591 15.0997 22.1372C15.0997 18.6153 12.1486 15.7603 8.50834 15.7603C4.86804 15.7603 1.91699 18.6153 1.91699 22.1372C1.91699 25.6591 4.86804 28.5142 8.50834 28.5142Z",
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_7",
                                    d: "M29.8321 13.4432C33.4789 13.4432 36.4352 10.583 36.4352 7.05483C36.4352 3.52666 33.4789 0.666504 29.8321 0.666504C26.1853 0.666504 23.229 3.52666 23.229 7.05483C23.229 10.583 26.1853 13.4432 29.8321 13.4432Z",
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_8",
                                    d: "M16.7414 52.8163C20.3945 52.8163 23.3559 49.9512 23.3559 46.4169C23.3559 42.8827 20.3945 40.0176 16.7414 40.0176C13.0884 40.0176 10.127 42.8827 10.127 46.4169C10.127 49.9512 13.0884 52.8163 16.7414 52.8163Z",
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_9",
                                    d: "M43.1345 52.7492C46.7797 52.7492 49.7347 49.8903 49.7347 46.3636C49.7347 42.837 46.7797 39.978 43.1345 39.978C39.4892 39.978 36.5342 42.837 36.5342 46.3636C36.5342 49.8903 39.4892 52.7492 43.1345 52.7492Z",
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_10",
                                    d: "M49.1617 16.0767C52.6338 14.9853 56.3625 16.8222 57.4901 20.1796C58.6177 23.5371 56.7171 27.1436 53.245 28.235L46.3353 30.4071C42.8632 31.4986 39.1345 29.6616 38.0069 26.3042C36.8793 22.9468 38.78 19.3402 42.2521 18.2488L49.1617 16.0767Z",
                                    fill: "url(#paint4_linear_3732_1157)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "Vector_11",
                                    d: "M51.2373 28.5147C47.597 28.5147 44.6459 25.6596 44.6459 22.1377C44.6459 18.6158 47.597 15.7607 51.2373 15.7607C54.8776 15.7607 57.8286 18.6158 57.8286 22.1377C57.8286 25.6596 54.8776 28.5147 51.2373 28.5147Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_3732_1157",
                        x1: "29.7863",
                        y1: "-11.5703",
                        x2: "29.9224",
                        y2: "21.8092",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.348958",
                                "stop-color": "white",
                                "stop-opacity": "0.95"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "white",
                                "stop-opacity": "0.2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_3732_1157",
                        x1: "-9.83306",
                        y1: "16.4238",
                        x2: "22.8171",
                        y2: "27.2322",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.348958",
                                "stop-color": "white",
                                "stop-opacity": "0.95"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "white",
                                "stop-opacity": "0.2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_3732_1157",
                        x1: "5.42924",
                        y1: "61.5374",
                        x2: "24.7226",
                        y2: "33.8451",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.348958",
                                "stop-color": "white",
                                "stop-opacity": "0.95"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "white",
                                "stop-opacity": "0.2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_3732_1157",
                        x1: "54.5042",
                        y1: "61.4165",
                        x2: "34.9756",
                        y2: "33.8788",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.348958",
                                "stop-color": "white",
                                "stop-opacity": "0.95"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "white",
                                "stop-opacity": "0.2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_3732_1157",
                        x1: "69.5777",
                        y1: "16.4238",
                        x2: "36.9275",
                        y2: "27.2322",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.348958",
                                "stop-color": "white",
                                "stop-opacity": "0.95"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "white",
                                "stop-opacity": "0.2"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/crm-icon.js

var CRMIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "115",
        height: "77",
        viewBox: "0 0 115 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M76.6747 35.5205C76.7798 37.0109 75.5603 38.2236 74.0681 38.2237L41.4712 38.2242C39.979 38.2243 38.7594 39.4371 38.8645 40.9275C39.4194 48.8025 42.3882 56.3366 47.3953 62.4735C52.9727 69.3095 60.7341 73.9888 69.357 75.7141C77.9798 77.4393 86.9306 76.1038 94.6843 71.9351C102.438 67.7663 108.515 61.0223 111.879 52.8521C115.244 44.6819 115.688 35.591 113.136 27.1284C110.583 18.6658 105.193 11.3551 97.883 6.442C90.5729 1.52889 81.7953 -0.682683 73.0459 0.18412C70.4321 0.443059 67.8693 0.971922 65.3943 1.75303C62.8564 2.54731 60.4103 3.60662 58.0961 4.91196C57.9578 4.98998 57.82 5.06888 57.6826 5.14865C63.5071 8.53128 68.3677 13.4285 71.7244 19.3729L71.7349 19.2104C71.7605 19.2554 71.7861 19.3004 71.8116 19.3455C74.631 24.3384 76.2763 29.8694 76.6747 35.5205Z",
                fill: "#00A0A0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "38.7706",
                cy: "38.2245",
                rx: "38.0015",
                ry: "38.2245",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "38.7706",
                cy: "38.2245",
                rx: "38.0015",
                ry: "38.2245",
                fill: "url(#paint0_linear_2481_124001-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M57.7774 71.3318C69.1327 64.7217 76.7721 52.3705 76.7721 38.2245C76.8043 36.6808 76.6748 35.5205 76.6748 35.5205C76.7472 36.9999 75.5603 38.2237 74.0681 38.2237L41.4712 38.2243C39.979 38.2243 38.7594 39.4372 38.8645 40.9275C39.4194 48.8025 42.3882 56.3367 47.3953 62.4735C50.3192 66.0573 53.8435 69.0484 57.7774 71.3318Z",
                fill: "url(#paint1_linear_2481_124001-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2481_124001-".concat(id),
                        x1: "12.3417",
                        y1: "15.2784",
                        x2: "76.9277",
                        y2: "48.0951",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00D2D2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00D2D2",
                                stopOpacity: "0.29"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_2481_124001-".concat(id),
                        x1: "80.8947",
                        y1: "57.9507",
                        x2: "20.4328",
                        y2: "45.4263",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00A0A0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00D2D2"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/crm-white.js

var CRMWhiteIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "43",
        height: "28",
        viewBox: "0 0 43 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Group 1261157990",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Group 1261162730",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "Ellipse 4942",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                    cx: "14.7227",
                                    cy: "14",
                                    rx: "13.978",
                                    ry: "13.5",
                                    fill: "#00D2D2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                    cx: "14.7227",
                                    cy: "14",
                                    rx: "13.978",
                                    ry: "13.5",
                                    fill: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "Union",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M28.6663 13.045C28.705 13.5714 28.2564 13.9997 27.7075 13.9997L15.7175 13.9999C15.1686 13.9999 14.72 14.4283 14.7587 14.9546C14.9628 17.7359 16.0548 20.3968 17.8965 22.5642C19.9481 24.9785 22.8029 26.6311 25.9747 27.2404C29.1464 27.8498 32.4387 27.3781 35.2908 25.9058C38.1428 24.4335 40.378 22.0516 41.6155 19.1661C42.8531 16.2806 43.0164 13.0699 42.0777 10.0811C41.1389 7.09232 39.1562 4.51036 36.4673 2.77517C33.7785 1.03997 30.5498 0.258892 27.3315 0.565027C26.3701 0.656478 25.4274 0.84326 24.5171 1.11913C23.5836 1.39965 22.6838 1.77378 21.8326 2.23479C21.7817 2.26234 21.731 2.29021 21.6805 2.31838C23.8229 3.51305 25.6108 5.24262 26.8455 7.34205L26.8493 7.28466C26.8588 7.30054 26.8682 7.31645 26.8775 7.33238C27.9146 9.09574 28.5198 11.0492 28.6663 13.045Z",
                                    fill: "white",
                                    "fill-opacity": "0.6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M28.6663 13.045C28.705 13.5714 28.2564 13.9997 27.7075 13.9997L15.7175 13.9999C15.1686 13.9999 14.72 14.4283 14.7587 14.9546C14.9628 17.7359 16.0548 20.3968 17.8965 22.5642C19.9481 24.9785 22.8029 26.6311 25.9747 27.2404C29.1464 27.8498 32.4387 27.3781 35.2908 25.9058C38.1428 24.4335 40.378 22.0516 41.6155 19.1661C42.8531 16.2806 43.0164 13.0699 42.0777 10.0811C41.1389 7.09232 39.1562 4.51036 36.4673 2.77517C33.7785 1.03997 30.5498 0.258892 27.3315 0.565027C26.3701 0.656478 25.4274 0.84326 24.5171 1.11913C23.5836 1.39965 22.6838 1.77378 21.8326 2.23479C21.7817 2.26234 21.731 2.29021 21.6805 2.31838C23.8229 3.51305 25.6108 5.24262 26.8455 7.34205L26.8493 7.28466C26.8588 7.30054 26.8682 7.31645 26.8775 7.33238C27.9146 9.09574 28.5198 11.0492 28.6663 13.045Z",
                                    fill: "url(#paint0_linear_3732_472)"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_3732_472",
                    x1: "38.8026",
                    y1: "8.60403",
                    x2: "14.9263",
                    y2: "17.2884",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            "stop-color": "#00A0A0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            "stop-color": "#00A0A0",
                            "stop-opacity": "0.5"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/marketing-icon.js

var MarketingIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "108",
        height: "77",
        viewBox: "0 0 108 77",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.8846 31.8694V74.0978C40.8846 75.3963 41.9317 76.449 43.2234 76.449H64.6875C65.9792 76.449 67.0263 75.3963 67.0263 74.0978V35.6944C67.0263 31.6893 70.2579 28.4425 74.2442 28.4425C78.2306 28.4425 81.4622 31.6893 81.4622 35.6944V74.0978C81.4622 75.3963 82.5093 76.449 83.8009 76.449H105.265C106.557 76.449 107.604 75.3963 107.604 74.0978V31.8694C107.604 14.2684 92.6684 0 74.2443 0C55.8203 0 40.8846 14.2684 40.8846 31.8694Z",
                fill: "#CA0C6B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.307129 31.8694V74.0978C0.307129 75.3963 1.35423 76.449 2.64591 76.449H24.11C25.4017 76.449 26.4488 75.3963 26.4488 74.0978V35.6944C26.4488 31.6893 29.6804 28.4425 33.6667 28.4425C37.6531 28.4425 40.8847 31.6893 40.8847 35.6944V74.0978C40.8847 75.3963 41.9318 76.449 43.2234 76.449H64.6877C65.9794 76.449 67.0265 75.3963 67.0265 74.0978V31.8694C67.0265 14.2684 52.0909 0 33.6668 0C15.2428 0 0.307129 14.2684 0.307129 31.8694Z",
                fill: "url(#paint0_linear_2481_123944-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.307129 51.8892H26.4453V74.1224C26.4453 75.4071 25.4086 76.4487 24.1299 76.4487H2.62255C1.34378 76.4487 0.307129 75.4071 0.307129 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40.8883 51.8892H67.0265V74.1224C67.0265 75.4071 65.9898 76.4487 64.711 76.4487H43.2037C41.925 76.4487 40.8883 75.4071 40.8883 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M81.469 51.8892H107.607V74.1224C107.607 75.4071 106.571 76.4487 105.292 76.4487H83.7844C82.5057 76.4487 81.469 75.4071 81.469 74.1224V51.8892Z",
                fill: "#F8C3DD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2481_123944-".concat(id),
                    x1: "-1.86843",
                    y1: "71.0347",
                    x2: "106.667",
                    y2: "57.1665",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#FF158A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.765625",
                            stopColor: "#FF158A",
                            stopOpacity: "0.5"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/project-management-icon.js

var ProjectManagementIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "108",
        height: "105",
        viewBox: "0 0 108 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.066 18.5174C27.066 16.0799 28.3867 13.8276 30.5307 12.6089L50.4255 1.29956C52.5695 0.0808159 55.2109 0.0808198 57.3549 1.29956L77.2498 12.6089C79.3937 13.8276 80.7145 16.0799 80.7145 18.5174L80.7156 45.0751L53.8913 60.3235C44.95 55.2407 36.0086 50.158 27.0671 45.0752C27.0671 36.2226 27.066 27.3702 27.066 18.5174Z",
                fill: "url(#paint0_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.0666 45.076C19.2958 49.5186 11.4929 53.9141 3.7059 58.3407C1.56195 59.5595 0.241213 61.8118 0.24121 64.2493L0.241212 86.8679C0.241212 89.3053 1.56194 91.5577 3.7059 92.7764L23.6007 104.086C25.7447 105.304 28.3862 105.304 30.5301 104.086L53.8908 90.821L53.8908 60.3243C44.9473 55.2404 36.007 50.1582 27.0666 45.076Z",
                fill: "url(#paint1_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M104.073 58.3406C106.217 59.5594 107.538 61.8117 107.538 64.2492L107.538 86.8678C107.538 89.3053 106.217 91.5576 104.073 92.7763L84.1785 104.086C82.0346 105.304 79.3931 105.304 77.2491 104.086L53.8891 90.8212L53.8891 60.3245C62.8305 55.2418 71.7719 50.1589 80.7133 45.0762C88.4865 49.5201 96.289 53.9156 104.073 58.3406Z",
                fill: "url(#paint2_linear_2481_124011-".concat(id, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                styles: "mix-blend-mode:multiply",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M27.066 47.0451C27.066 45.8264 27.7264 44.7002 28.7984 44.0908L52.1579 30.812C53.2299 30.2026 54.5506 30.2026 55.6226 30.812L78.9822 44.0908C80.0541 44.7002 80.7145 45.8263 80.7145 47.0451L80.7145 73.6027C80.7145 74.8215 80.0541 75.9476 78.9822 76.557L55.6226 89.8358C54.5507 90.4452 53.2299 90.4452 52.1579 89.8358L28.7984 76.557C27.7264 75.9476 27.0661 74.8215 27.0661 73.6027L27.066 47.0451Z",
                    fill: "url(#paint3_linear_2481_124011-".concat(id, ")")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2481_124011-".concat(id),
                        x1: "27.0659",
                        y1: "14.6157",
                        x2: "80.2724",
                        y2: "45.841",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_2481_124011-".concat(id),
                        x1: "53.8897",
                        y1: "60.2978",
                        x2: "0.683283",
                        y2: "91.523",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_2481_124011-".concat(id),
                        x1: "53.8897",
                        y1: "60.2976",
                        x2: "107.096",
                        y2: "91.5224",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FB9000"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_2481_124011-".concat(id),
                        x1: "53.8903",
                        y1: "30.355",
                        x2: "53.8903",
                        y2: "90.2929",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FDAB3D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCB00",
                                stopOpacity: "0.51"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/software-icon.js

var SoftwareIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "119",
        height: "90",
        viewBox: "0 0 119 90",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "119",
                height: "90",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M46.3084 16.662C46.3084 10.2213 51.5296 5 57.9704 5C79.6724 5 97.2578 22.5854 97.2578 44.2874C97.2578 65.9895 79.6724 83.5748 57.9704 83.5748H14.662C8.22126 83.5748 3 78.3536 3 71.9128C3 65.4721 8.22126 60.2508 14.662 60.2508H57.9704C66.7909 60.2508 73.9338 53.108 73.9338 44.2874C73.9338 35.4669 66.7909 28.324 57.9704 28.324C51.5296 28.324 46.3084 23.1028 46.3084 16.662Z",
                fill: "url(#paint0_linear_2426_1297)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M19.3438 44.2874C19.3438 22.5854 36.9291 5 58.6312 5C65.0719 5 70.2932 10.2213 70.2932 16.662C70.2932 23.1028 65.0719 28.324 58.6312 28.324C49.8106 28.324 42.6678 35.4669 42.6678 44.2874C42.6678 53.108 49.8106 60.2508 58.6312 60.2508H106.503V83.5748H58.6312C36.9291 83.5748 19.3438 65.9895 19.3438 44.2874Z",
                fill: "#00CA72"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M116.834 69.1374C118.389 70.6837 118.389 73.1999 116.834 74.7462L109.094 82.4428C106.6 84.9237 102.35 83.1567 102.35 79.6384L102.35 64.2452C102.35 60.7269 106.6 58.9599 109.094 61.4408L116.834 69.1374Z",
                fill: "#00CA72"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2426_1297",
                    x1: "74.4638",
                    y1: "31.3159",
                    x2: "67.4632",
                    y2: "63.8687",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            "stop-color": "#00CA72"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.905957",
                            "stop-color": "#00CA72",
                            "stop-opacity": "0.6"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/software-white.js

var SoftwareWhiteIcon = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "45",
        height: "33",
        viewBox: "0 0 45 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group 1261160633",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector",
                        d: "M5.12256 25.1277H21.1478C26.7948 25.1277 31.3699 20.6479 31.3699 15.1185C31.3699 9.5891 26.7948 5.10938 21.1478 5.10938",
                        stroke: "url(#paint0_linear_3732_2139)",
                        "stroke-width": "9.10995",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector_2",
                        d: "M21.3832 9.66435C23.8989 9.66435 25.9382 7.62502 25.9382 5.10938C25.9382 2.59373 23.8989 0.554398 21.3832 0.554398V9.66435ZM34.7819 29.6826H39.3369V20.5727H34.7819V29.6826ZM21.3832 0.554398C13.3114 0.554398 6.60616 6.98352 6.60616 15.1185H15.7161C15.7161 12.1947 18.1609 9.66435 21.3832 9.66435V0.554398ZM6.60616 15.1185C6.60616 23.2535 13.3114 29.6826 21.3832 29.6826V20.5727C18.1609 20.5727 15.7161 18.0424 15.7161 15.1185H6.60616ZM21.3832 29.6826H34.7819V20.5727H21.3832V29.6826Z",
                        fill: "url(#paint1_linear_3732_2139)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Polygon 1",
                        d: "M43.345 23.9987C43.9711 24.6213 43.9711 25.6344 43.345 26.2569L40.3813 29.2043C39.3768 30.2032 37.666 29.4917 37.666 28.0752L37.666 22.1805C37.666 20.7639 39.3768 20.0525 40.3813 21.0513L43.345 23.9987Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_3732_2139",
                        x1: "24.0076",
                        y1: "7.83206",
                        x2: "24.0076",
                        y2: "20.0842",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                "stop-color": "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.905957",
                                "stop-color": "white",
                                "stop-opacity": "0.6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_3732_2139",
                        x1: "35.0217",
                        y1: "27.0324",
                        x2: "24.4352",
                        y2: "12.4881",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.193864",
                                "stop-color": "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "white"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/icons/product-icon.js










var productNameToIconMap = {
    core: CoreIcon,
    projectManagement: ProjectManagementIcon,
    software: SoftwareIcon,
    marketing: MarketingIcon,
    crm: CRMIcon,
    coreWhite: CoreWhiteIcon,
    softwareWhite: SoftwareWhiteIcon,
    crmWhite: CRMWhiteIcon
};
var ProductIcon = function(param) {
    var product = param.product;
    var IconComponent = productNameToIconMap[product];
    return IconComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {
        id: (0,v4/* default */.Z)()
    }) : null;
};


/***/ })

}]);